import { useState, useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';

const STATUS_STYLE = {
  draft:     { bg: '#f9fafb', color: '#6b7280', label: 'statusDraft', icon: '✏️' },
  submitted: { bg: '#fffbeb', color: '#92400e', label: 'statusSubmitted', icon: '⏳' },
  pending:   { bg: '#fffbeb', color: '#92400e', label: 'statusPending', icon: '⏳' },
  approved:  { bg: '#f0fdf4', color: '#166534', label: 'statusApproved', icon: '✅' },
  rejected:  { bg: '#e8f4fc', color: '#dc2626', label: 'statusRejected', icon: '❌' },
};
const STATUS_OPTS = ['submitted', 'approved', 'rejected'];

const inputStyle = {
  width: '100%', padding: '9px 12px', border: '1.5px solid #e5e7eb',
  borderRadius: 8, fontSize: 14, outline: 'none', boxSizing: 'border-box',
  fontFamily: 'inherit',
};

function ProductsTable({ items, setItems, products, t }) {
  const addRow = () => setItems(prev => [...prev, { product_id: '', product_name: '', product_sku: '', quantity: 1, note: '' }]);
  const removeRow = (i) => setItems(prev => prev.filter((_, idx) => idx !== i));
  const updateRow = (i, key, val) => setItems(prev => prev.map((row, idx) => idx === i ? { ...row, [key]: val } : row));
  const selectProduct = (i, id) => {
    const p = products.find(p => String(p.id) === String(id));
    if (p) {
      updateRow(i, 'product_id', p.id);
      updateRow(i, 'product_name', p.name);
      updateRow(i, 'product_sku', p.sku || p.part_number || '');
    }
  };
  return (
    <div style={{ marginBottom: 20 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 10 }}>
        <label style={{ fontSize: 13, fontWeight: 600, color: '#374151' }}>📦 {t('products')} <span style={{ color: '#0e76bc' }}>*</span></label>
        <button type="button" onClick={addRow} style={{ background: 'linear-gradient(135deg, #0e76bc, #0b5e96)', color: '#fff', border: 'none', borderRadius: 6, padding: '5px 12px', fontSize: 12, fontWeight: 700, cursor: 'pointer', fontFamily: 'inherit' }}>+ Přidat produkt</button>
      </div>
      {items.length === 0 && (
        <div style={{ textAlign: 'center', padding: '20px', color: '#9ca3af', background: '#f9fafb', borderRadius: 8, border: '1.5px dashed #e5e7eb', fontSize: 13 }}>Klikněte na "+ Přidat produkt"</div>
      )}
      {items.length > 0 && (
        <div style={{ border: '1.5px solid #e5e7eb', borderRadius: 8, overflow: 'hidden' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
            <thead>
              <tr style={{ background: '#f9fafb' }}>
                <th style={{ padding: '8px 12px', textAlign: 'left', fontWeight: 600, color: '#6b7280', borderBottom: '1px solid #e5e7eb', width: '40%' }}>Produkt</th>
                <th style={{ padding: '8px 12px', textAlign: 'left', fontWeight: 600, color: '#6b7280', borderBottom: '1px solid #e5e7eb', width: '15%' }}>SKU</th>
                <th style={{ padding: '8px 12px', textAlign: 'left', fontWeight: 600, color: '#6b7280', borderBottom: '1px solid #e5e7eb', width: '10%' }}>Množství</th>
                <th style={{ padding: '8px 12px', textAlign: 'left', fontWeight: 600, color: '#6b7280', borderBottom: '1px solid #e5e7eb' }}>Poznámka</th>
                <th style={{ padding: '8px 12px', borderBottom: '1px solid #e5e7eb', width: 36 }}></th>
              </tr>
            </thead>
            <tbody>
              {items.map((row, i) => (
                <tr key={i} style={{ borderBottom: i < items.length - 1 ? '1px solid #f3f4f6' : 'none' }}>
                  <td style={{ padding: '8px 12px' }}>
                    <select value={row.product_id} onChange={e => selectProduct(i, e.target.value)} style={{ ...inputStyle, padding: '7px 10px' }}>
                      <option value="">-- Vyberte produkt --</option>
                      {products.map(p => <option key={p.id} value={p.id}>{p.name}{p.sku ? ` (${p.sku})` : ''}</option>)}
                    </select>
                  </td>
                  <td style={{ padding: '8px 12px', color: '#6b7280', fontSize: 12 }}>{row.product_sku}</td>
                  <td style={{ padding: '8px 12px' }}>
                    <input type="number" min="1" value={row.quantity} onChange={e => updateRow(i, 'quantity', parseInt(e.target.value) || 1)} style={{ ...inputStyle, width: 70, padding: '7px 10px', textAlign: 'center' }} />
                  </td>
                  <td style={{ padding: '8px 12px' }}>
                    <input type="text" value={row.note} placeholder="volitelná poznámka" onChange={e => updateRow(i, 'note', e.target.value)} style={{ ...inputStyle, padding: '7px 10px' }} />
                  </td>
                  <td style={{ padding: '8px 12px' }}>
                    <button type="button" onClick={() => removeRow(i)} style={{ background: 'none', border: 'none', color: '#ef4444', cursor: 'pointer', fontSize: 18, lineHeight: 1, padding: 2 }}>×</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

function ProjectForm({ t, lang, onSubmit, onCancel, products, subdistributors, isAdmin, users, initialProject }) {
  const [form, setForm] = useState(initialProject ? {
    project_name: initialProject.project_name || '',
    end_customer: initialProject.end_customer || '',
    end_customer_address: initialProject.end_customer_address || '',
    end_customer_ico: initialProject.end_customer_ico || '',
    realization_date: initialProject.realization_date || '',
    description: initialProject.description || '',
    estimated_value: initialProject.estimated_value || '',
    currency: initialProject.currency || 'CZK',
    subdistributor_id: initialProject.subdistributor_id || 1,
    on_behalf_of: '',
  } : { project_name: '', end_customer: '', end_customer_address: '', end_customer_ico: '', realization_date: '', description: '', estimated_value: '', currency: 'CZK', subdistributor_id: 1, on_behalf_of: '' });
  const [items, setItems] = useState(() => {
    if (initialProject?.items?.length > 0) {
      return initialProject.items.map(i => ({ id: i.id, product_id: i.product_id, product_name: i.product_name, product_sku: i.product_sku || '', quantity: i.quantity }));
    }
    try {
      const prefill = sessionStorage.getItem('prefillProducts');
      const type = sessionStorage.getItem('prefillType');
      if (prefill && type === 'project') {
        sessionStorage.removeItem('prefillProducts');
        sessionStorage.removeItem('prefillType');
        return JSON.parse(prefill);
      }
    } catch(e) {}
    return [];
  });
  const [loading, setLoading] = useState(false);
  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));

  const handleSubmitProject = async (id) => {
    if (!window.confirm('Odeslat projekt ke schválení? Po odeslání jej již nelze upravovat.')) return;
    await apiFetch(`/projects/${id}/submit`, { method: 'PUT' });
    load();
  };

  const handleEditProject = (p) => {
    setEditingDraft(p);
    window.scrollTo(0, 0);
  };

  const handleSubmit = async () => {
    if (!form.project_name || !form.end_customer || items.length === 0) return;
    const validItems = items.filter(i => i.product_name && i.quantity > 0);
    if (validItems.length === 0) { alert('Přidejte alespoň jeden produkt.'); return; }
    setLoading(true);
    await onSubmit({ ...form, items: validItems });
    setLoading(false);
  };

  const field = (label, key, type = 'text', required = false, fullWidth = false) => (
    <div style={{ marginBottom: 16, ...(fullWidth ? { gridColumn: '1 / -1' } : {}) }}>
      <label style={{ display: 'block', fontSize: 13, fontWeight: 600, color: '#374151', marginBottom: 5 }}>{label} {required && <span style={{ color: '#0e76bc' }}>*</span>}</label>
      {type === 'textarea' ? <textarea value={form[key]} onChange={e => set(key, e.target.value)} rows={3} style={{ ...inputStyle, resize: 'vertical' }} /> : <input type={type} value={form[key]} onChange={e => set(key, e.target.value)} style={inputStyle} />}
    </div>
  );

  return (
    <div style={{ background: '#fff', borderRadius: 12, padding: '28px', boxShadow: '0 1px 6px rgba(0,0,0,0.06)', border: '1px solid #f3f4f6', marginBottom: 28 }}>
      <h2 style={{ margin: '0 0 24px', fontSize: 18, fontWeight: 700, color: '#111827' }}>{t('newProject')}</h2>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0 20px' }}>
        {field(t('projectName'), 'project_name', 'text', true, true)}
        {field(t('endCustomer'), 'end_customer', 'text', true)}
        {field(t('endCustomerAddress'), 'end_customer_address')}
        {field('IČ koncového zákazníka', 'end_customer_ico')}
        <div style={{ marginBottom: 16 }}>
          <label style={{ display: 'block', fontSize: 13, fontWeight: 600, color: '#374151', marginBottom: 5 }}>Předpokládané datum realizace</label>
          <div style={{ display: 'flex', gap: 8 }}>
            <select value={form.realization_date ? form.realization_date.split('-')[1] : ''} onChange={e => { const year = form.realization_date ? form.realization_date.split('-')[0] : new Date().getFullYear(); set('realization_date', e.target.value ? `${year}-${e.target.value}` : ''); }} style={{ ...inputStyle, background: '#fff', flex: 1 }}>
              <option value="">-- Měsíc --</option>
              {['01','02','03','04','05','06','07','08','09','10','11','12'].map((m, i) => <option key={m} value={m}>{['Leden','Únor','Březen','Duben','Květen','Červen','Červenec','Srpen','Září','Říjen','Listopad','Prosinec'][i]}</option>)}
            </select>
            <select value={form.realization_date ? form.realization_date.split('-')[0] : ''} onChange={e => { const month = form.realization_date ? form.realization_date.split('-')[1] : '01'; set('realization_date', e.target.value ? `${e.target.value}-${month}` : ''); }} style={{ ...inputStyle, background: '#fff', flex: 1 }}>
              <option value="">-- Rok --</option>
              {Array.from({length: 6}, (_, i) => new Date().getFullYear() + i).map(y => <option key={y} value={y}>{y}</option>)}
            </select>
          </div>
        </div>
        {field(t('description'), 'description', 'textarea', false, true)}
      </div>

      <div style={{ marginBottom: 20 }}>
        <label style={{ display: 'block', fontSize: 13, fontWeight: 600, color: '#374151', marginBottom: 5 }}>🏪 Dodavatel <span style={{ color: '#0e76bc' }}>*</span></label>
        <select value={form.subdistributor_id} onChange={e => set('subdistributor_id', Number(e.target.value))} style={{ ...inputStyle, background: '#fff' }}>
          {subdistributors.map(s => <option key={s.id} value={s.id}>{s.name} ({s.country})</option>)}
        </select>
      </div>

      {isAdmin && users.length > 0 && (
        <div style={{ marginBottom: 20, padding: '14px 16px', background: '#e8f4fc', borderRadius: 8, border: '1px solid #b3d9f2' }}>
          <label style={{ display: 'block', fontSize: 13, fontWeight: 600, color: '#0e76bc', marginBottom: 5 }}>👤 Zadat jménem uživatele (admin)</label>
          <select value={form.on_behalf_of} onChange={e => set('on_behalf_of', e.target.value ? Number(e.target.value) : '')} style={{ ...inputStyle, background: '#fff' }}>
            <option value="">-- Vlastní účet (admin) --</option>
            {users.filter(u => u.role !== 'admin').map(u => (
              <option key={u.id} value={u.id}>{u.first_name} {u.last_name} – {u.company_name} ({u.email})</option>
            ))}
          </select>
        </div>
      )}

      <ProductsTable items={items} setItems={setItems} products={products} t={t} />

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0 20px' }}>
        {field(t('estimatedValue'), 'estimated_value', 'number')}
        <div style={{ marginBottom: 16 }}>
          <label style={{ display: 'block', fontSize: 13, fontWeight: 600, color: '#374151', marginBottom: 5 }}>{t('currency')}</label>
          <select value={form.currency} onChange={e => set('currency', e.target.value)} style={{ ...inputStyle, background: '#fff' }}>
            {['CZK', 'EUR', 'USD', 'RON'].map(c => <option key={c}>{c}</option>)}
          </select>
        </div>
      </div>

      <div style={{ display: 'flex', gap: 12, marginTop: 8 }}>
        <button onClick={handleSubmit} disabled={loading || !form.project_name || !form.end_customer || items.length === 0} style={{ background: 'linear-gradient(135deg, #0e76bc, #0b5e96)', color: '#fff', border: 'none', borderRadius: 8, padding: '10px 22px', fontSize: 14, fontWeight: 700, cursor: 'pointer', fontFamily: 'inherit', opacity: loading || !form.project_name || !form.end_customer || items.length === 0 ? 0.5 : 1 }}>{t('submit')}</button>
        <button onClick={onCancel} style={{ background: '#f9fafb', color: '#374151', border: '1px solid #e5e7eb', borderRadius: 8, padding: '10px 18px', fontSize: 14, fontWeight: 600, cursor: 'pointer', fontFamily: 'inherit' }}>{t('cancel')}</button>
      </div>
    </div>
  );
}

function EditProjectInline({ p, t, onSave, onCancel }) {
  const STATUS_OPTS = ['submitted', 'approved', 'rejected'];
  const [status, setStatus] = useState(p.status);
  const [note, setNote] = useState(p.admin_note || '');
  const [discount, setDiscount] = useState(p.discount_percent || '');
  const [i6, setI6] = useState(p.i6_reference || '');
  const [itemPrices, setItemPrices] = useState(
    (p.items || []).map(item => ({
      id: item.id,
      product_name: item.product_name,
      product_sku: item.product_sku,
      quantity: item.quantity,
      unit_price: item.unit_price ?? '',
      item_discount: item.discount_percent ?? '',
      final_price: item.final_price ?? '',
    }))
  );

  const updateItem = (idx, field, val) => {
    setItemPrices(prev => {
      const next = [...prev];
      next[idx] = { ...next[idx], [field]: val };
      // Auto-calculate final_price
      const item = next[idx];
      if (field === 'unit_price' || field === 'item_discount') {
        const up = parseFloat(field === 'unit_price' ? val : item.unit_price);
        const disc = parseFloat(field === 'item_discount' ? val : item.item_discount);
        if (!isNaN(up) && !isNaN(disc)) {
          next[idx].final_price = (up * item.quantity * (1 - disc / 100)).toFixed(2);
        } else if (!isNaN(up) && item.item_discount === '') {
          next[idx].final_price = (up * item.quantity).toFixed(2);
        }
      }
      return next;
    });
  };

  const inp = (val, onChange, placeholder = '', width = 90) => (
    <input value={val} onChange={e => onChange(e.target.value)} placeholder={placeholder}
      style={{ width, padding: '5px 8px', border: '1.5px solid #e5e7eb', borderRadius: 6, fontSize: 12, fontFamily: 'inherit', boxSizing: 'border-box' }} />
  );

  return (
    <div style={{ marginTop: 14, paddingTop: 14, borderTop: '1px solid #f3f4f6' }}>
      {/* Item pricing table */}
      {itemPrices.length > 0 && (
        <div style={{ marginBottom: 16 }}>
          <div style={{ fontSize: 12, fontWeight: 700, color: '#374151', marginBottom: 8 }}>💰 Ceny produktů</div>
          <div style={{ border: '1px solid #e5e7eb', borderRadius: 8, overflow: 'hidden' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 12 }}>
              <thead>
                <tr style={{ background: '#f9fafb' }}>
                  <th style={{ padding: '7px 10px', textAlign: 'left', color: '#6b7280', fontWeight: 600, borderBottom: '1px solid #e5e7eb' }}>Produkt</th>
                  <th style={{ padding: '7px 10px', textAlign: 'center', color: '#6b7280', fontWeight: 600, borderBottom: '1px solid #e5e7eb' }}>Ks</th>
                  <th style={{ padding: '7px 10px', textAlign: 'center', color: '#6b7280', fontWeight: 600, borderBottom: '1px solid #e5e7eb' }}>Jedn. cena</th>
                  <th style={{ padding: '7px 10px', textAlign: 'center', color: '#6b7280', fontWeight: 600, borderBottom: '1px solid #e5e7eb' }}>Sleva %</th>
                  <th style={{ padding: '7px 10px', textAlign: 'center', color: '#6b7280', fontWeight: 600, borderBottom: '1px solid #e5e7eb' }}>Celkem</th>
                </tr>
              </thead>
              <tbody>
                {itemPrices.map((item, idx) => (
                  <tr key={item.id} style={{ borderBottom: idx < itemPrices.length - 1 ? '1px solid #f3f4f6' : 'none' }}>
                    <td style={{ padding: '7px 10px', fontWeight: 600, color: '#111827' }}>
                      {item.product_name}
                      {item.product_sku && <div style={{ fontSize: 11, color: '#9ca3af', fontFamily: 'monospace' }}>{item.product_sku}</div>}
                    </td>
                    <td style={{ padding: '7px 10px', textAlign: 'center', color: '#374151', fontWeight: 700 }}>{item.quantity}</td>
                    <td style={{ padding: '7px 10px', textAlign: 'center' }}>
                      {inp(item.unit_price, v => updateItem(idx, 'unit_price', v), '0.00')}
                    </td>
                    <td style={{ padding: '7px 10px', textAlign: 'center' }}>
                      {inp(item.item_discount, v => updateItem(idx, 'item_discount', v), '0', 70)}
                    </td>
                    <td style={{ padding: '7px 10px', textAlign: 'center' }}>
                      {inp(item.final_price, v => updateItem(idx, 'final_price', v), '0.00')}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div style={{ fontSize: 11, color: '#9ca3af', marginTop: 4 }}>Celková cena se vypočítá automaticky z jednotkové ceny × množství × (1 - sleva%). Nebo zadejte celkovou cenu přímo.</div>
        </div>
      )}

      {/* Project-level fields */}
      <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap', alignItems: 'flex-end' }}>
        <div>
          <label style={{ display: 'block', fontSize: 12, fontWeight: 600, color: '#374151', marginBottom: 4 }}>Stav</label>
          <select value={status} onChange={e => setStatus(e.target.value)} style={{ padding: '7px 10px', border: '1.5px solid #e5e7eb', borderRadius: 7, fontSize: 13, background: '#fff', fontFamily: 'inherit' }}>
            {STATUS_OPTS.map(s => <option key={s} value={s}>{t(`status${s.charAt(0).toUpperCase() + s.slice(1)}`)}</option>)}
          </select>
        </div>
        <div>
          <label style={{ display: 'block', fontSize: 12, fontWeight: 600, color: '#374151', marginBottom: 4 }}>Sleva na celý projekt (%)</label>
          <input type="number" value={discount} onChange={e => setDiscount(e.target.value)} min="0" max="100" style={{ width: 100, padding: '7px 10px', border: '1.5px solid #e5e7eb', borderRadius: 7, fontSize: 13, fontFamily: 'inherit' }} />
        </div>
        <div style={{ flex: 1, minWidth: 180 }}>
          <label style={{ display: 'block', fontSize: 12, fontWeight: 600, color: '#374151', marginBottom: 4 }}>Poznámka pro prodejce</label>
          <input value={note} onChange={e => setNote(e.target.value)} style={{ width: '100%', padding: '7px 10px', border: '1.5px solid #e5e7eb', borderRadius: 7, fontSize: 13, fontFamily: 'inherit', boxSizing: 'border-box' }} />
        </div>
        <div style={{ flex: 1, minWidth: 160 }}>
          <label style={{ display: 'block', fontSize: 12, fontWeight: 600, color: '#0369a1', marginBottom: 4 }}>Projekt v i6</label>
          <input value={i6} onChange={e => setI6(e.target.value)} placeholder="Reference v i6..." style={{ width: '100%', padding: '7px 10px', border: '1.5px solid #bae6fd', borderRadius: 7, fontSize: 13, fontFamily: 'inherit', boxSizing: 'border-box', background: '#f0f9ff' }} />
        </div>
        <button onClick={() => onSave({ status, admin_note: note, discount_percent: discount || null, i6_reference: i6, items: itemPrices })} style={{ background: 'linear-gradient(135deg, #0e76bc, #0b5e96)', color: '#fff', border: 'none', borderRadius: 8, padding: '9px 18px', fontSize: 13, fontWeight: 700, cursor: 'pointer', fontFamily: 'inherit' }}>Uložit</button>
        <button onClick={onCancel} style={{ background: '#f9fafb', color: '#374151', border: '1px solid #e5e7eb', borderRadius: 8, padding: '9px 14px', fontSize: 13, fontWeight: 600, cursor: 'pointer', fontFamily: 'inherit' }}>Zrušit</button>
      </div>
    </div>
  );
}

export default function ProjectsPage() {
  const { user, lang, t, apiFetch } = useAuth();
  const isAdmin = user?.role === 'admin';
  const isSubdist = user?.role === 'subdistributor';
  const canSeePrices = isAdmin || isSubdist;
  const [projects, setProjects] = useState([]);
  const [products, setProducts] = useState([]);
  const [subdistributors, setSubdistributors] = useState([]);
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(() => {
    return sessionStorage.getItem('prefillType') === 'project' || 
           !!sessionStorage.getItem('prefillProducts');
  });
  const [editing, setEditing] = useState(null);
  const [editingDraft, setEditingDraft] = useState(null);
  const [editingAdmin, setEditingAdmin] = useState(null);
  const [toast, setToast] = useState(null);
  const [filters, setFilters] = useState({ project_name: '', end_customer: '', end_customer_ico: '', date_from: '', date_to: '', realization_from: '', realization_to: '' });
  const [showFilters, setShowFilters] = useState(false);
  const setF = (k, v) => setFilters(f => ({ ...f, [k]: v }));

  const locale = lang === 'cs' ? 'cs-CZ' : lang === 'sk' ? 'sk-SK' : 'ro-RO';

  const load = () => Promise.all([
    apiFetch('/projects'),
    apiFetch('/products'),
    apiFetch('/subdistributors'),
    isAdmin ? apiFetch('/admin/users') : Promise.resolve([]),
  ]).then(([proj, prod, subdist, users]) => {
    setProjects(proj);
    setProducts(prod);
    setSubdistributors(subdist);
    if (isAdmin) setUsers(users);
  }).finally(() => setLoading(false));

  useEffect(() => { load(); }, [apiFetch]);

  const showToast = (msg, type = 'success') => { setToast({ msg, type }); setTimeout(() => setToast(null), 4000); };

  const handleSubmit = async (form) => {
    try {
      await apiFetch('/projects', { method: 'POST', body: JSON.stringify(form) });
      showToast(t('projectSubmitted'));
      setShowForm(false);
      load();
    } catch (e) { showToast(e.message, 'error'); }
  };

  const updateProject = async (id, data) => {
    try {
      await apiFetch(`/admin/projects/${id}`, { method: 'PUT', body: JSON.stringify(data) });
      setEditing(null);
      load();
    } catch (e) { showToast(e.message, 'error'); }
  };

  const filtered = projects.filter(p => {
    if (filters.project_name && !p.project_name.toLowerCase().includes(filters.project_name.toLowerCase())) return false;
    if (filters.end_customer && !p.end_customer.toLowerCase().includes(filters.end_customer.toLowerCase())) return false;
    if (filters.end_customer_ico && !(p.end_customer_ico||'').toLowerCase().includes(filters.end_customer_ico.toLowerCase())) return false;
    if (filters.date_from && new Date(p.created_at) < new Date(filters.date_from)) return false;
    if (filters.date_to && new Date(p.created_at) > new Date(filters.date_to + 'T23:59:59')) return false;
    if (filters.realization_from && p.realization_date && p.realization_date < filters.realization_from) return false;
    if (filters.realization_to && p.realization_date && p.realization_date > filters.realization_to) return false;
    return true;
  });

  const activeFilters = Object.values(filters).filter(Boolean).length;
  const clearFilters = () => setFilters({ project_name: '', end_customer: '', end_customer_ico: '', date_from: '', date_to: '', realization_from: '', realization_to: '' });

  const fInp = (label, key, type='text') => (
    <div>
      <label style={{ display: 'block', fontSize: 11, fontWeight: 600, color: '#6b7280', marginBottom: 4 }}>{label}</label>
      <input type={type} value={filters[key]} onChange={e => setF(key, e.target.value)}
        style={{ width: '100%', padding: '7px 10px', border: '1.5px solid #e5e7eb', borderRadius: 7, fontSize: 13, fontFamily: 'inherit', boxSizing: 'border-box', background: filters[key] ? '#e8f4fc' : '#fff' }} />
    </div>
  );

  if (loading) return <div style={{ textAlign: 'center', padding: 60, color: '#9ca3af' }}>{t('loading')}</div>;

  const STATUS_COLOR = { pending: '#92400e', approved: '#166534', rejected: '#991b1b' };
  const STATUS_BG = { pending: '#fffbeb', approved: '#f0fdf4', rejected: '#e8f4fc' };

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
        <h1 style={{ margin: 0, fontSize: 26, fontWeight: 800, color: '#111827' }}>📁 {t('projectsTitle')}</h1>
        {!showForm && (
          <button onClick={() => setShowForm(true)} style={{ background: 'linear-gradient(135deg, #0e76bc, #0b5e96)', color: '#fff', border: 'none', borderRadius: 8, padding: '10px 18px', fontSize: 14, fontWeight: 700, cursor: 'pointer', fontFamily: 'inherit' }}>
            + {t('newProject')}
          </button>
        )}
      </div>
      <p style={{ margin: '0 0 24px', color: '#6b7280', fontSize: 14 }}>{t('projectsSubtitle')}</p>

      {toast && (
        <div style={{ position: 'fixed', top: 80, right: 24, background: toast.type === 'error' ? '#e8f4fc' : '#f0fdf4', border: `1px solid ${toast.type === 'error' ? '#b3d9f2' : '#bbf7d0'}`, color: toast.type === 'error' ? '#dc2626' : '#166534', borderRadius: 10, padding: '14px 20px', boxShadow: '0 4px 16px rgba(0,0,0,0.1)', zIndex: 999, fontSize: 14, fontWeight: 500, maxWidth: 380 }}>{toast.msg}</div>
      )}

      {showForm && <ProjectForm t={t} lang={lang} onSubmit={handleSubmit} onCancel={() => setShowForm(false)} products={products} subdistributors={subdistributors} isAdmin={isAdmin} users={users} />}
      {editingDraft && (
        <ProjectForm
          t={t} lang={lang}
          initialProject={editingDraft}
          products={products}
          subdistributors={subdistributors}
          isAdmin={isAdmin}
          users={users}
          onSubmit={async (data) => {
            await apiFetch(`/projects/${editingDraft.id}`, { method: 'PUT', body: JSON.stringify(data) });
            setEditingDraft(null); load();
          }}
          onCancel={() => setEditingDraft(null)}
        />
      )}
      {editingAdmin && (
        <ProjectForm
          t={t} lang={lang}
          initialProject={editingAdmin}
          products={products}
          subdistributors={subdistributors}
          isAdmin={isAdmin}
          users={users}
          onSubmit={async (data) => {
            await apiFetch(`/admin/projects/${editingAdmin.id}`, { method: 'PUT', body: JSON.stringify({ ...data, status: editingAdmin.status, admin_note: editingAdmin.admin_note, discount_percent: editingAdmin.discount_percent, i6_reference: editingAdmin.i6_reference }) });
            setEditingAdmin(null); load();
          }}
          onCancel={() => setEditingAdmin(null)}
        />
      )}

      {/* Admin filters */}
      {isAdmin && !showForm && (
        <div style={{ marginBottom: 16 }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: showFilters ? 12 : 0 }}>
            <span style={{ fontWeight: 700, fontSize: 15, color: '#374151' }}>
              {filtered.length} / {projects.length} projektů
              {activeFilters > 0 && <span style={{ marginLeft: 8, background: '#e8f4fc', color: '#0e76bc', fontSize: 11, fontWeight: 700, padding: '2px 8px', borderRadius: 10 }}>{activeFilters} filtr</span>}
            </span>
            <div style={{ display: 'flex', gap: 8 }}>
              {activeFilters > 0 && <button onClick={clearFilters} style={{ background: 'none', border: '1px solid #e5e7eb', color: '#374151', borderRadius: 6, padding: '6px 12px', fontSize: 13, cursor: 'pointer', fontFamily: 'inherit' }}>Zrušit filtry</button>}
              <button onClick={() => setShowFilters(!showFilters)} style={{ background: showFilters ? '#e8f4fc' : '#f9fafb', border: '1px solid #e5e7eb', color: showFilters ? '#0e76bc' : '#374151', borderRadius: 6, padding: '6px 12px', fontSize: 13, cursor: 'pointer', fontFamily: 'inherit', fontWeight: 600 }}>
                {showFilters ? '▲ Skrýt filtry' : '▼ Filtrovat'}
              </button>
            </div>
          </div>
          {showFilters && (
            <div style={{ background: '#f9fafb', border: '1px solid #e5e7eb', borderRadius: 10, padding: 16, marginTop: 12 }}>
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))', gap: 12 }}>
                {fInp('Název projektu', 'project_name')}
                {fInp('Koncový zákazník', 'end_customer')}
                {fInp('IČ zákazníka', 'end_customer_ico')}
                {fInp('Zadáno od', 'date_from', 'date')}
                {fInp('Zadáno do', 'date_to', 'date')}
                <div>
                  <label style={{ display: 'block', fontSize: 11, fontWeight: 600, color: '#6b7280', marginBottom: 4 }}>Realizace od</label>
                  <div style={{ display: 'flex', gap: 4 }}>
                    <select value={filters.realization_from ? filters.realization_from.split('-')[1] : ''} onChange={e => { const y = filters.realization_from ? filters.realization_from.split('-')[0] : new Date().getFullYear(); setF('realization_from', e.target.value ? `${y}-${e.target.value}` : ''); }} style={{ flex: 1, padding: '7px 6px', border: '1.5px solid #e5e7eb', borderRadius: 7, fontSize: 12, fontFamily: 'inherit', background: '#fff' }}>
                      <option value="">Měs.</option>
                      {['01','02','03','04','05','06','07','08','09','10','11','12'].map((m,i) => <option key={m} value={m}>{['Led','Úno','Bře','Dub','Kvě','Čer','Čvc','Srp','Zář','Říj','Lis','Pro'][i]}</option>)}
                    </select>
                    <select value={filters.realization_from ? filters.realization_from.split('-')[0] : ''} onChange={e => { const m = filters.realization_from ? filters.realization_from.split('-')[1] : '01'; setF('realization_from', e.target.value ? `${e.target.value}-${m}` : ''); }} style={{ flex: 1, padding: '7px 6px', border: '1.5px solid #e5e7eb', borderRadius: 7, fontSize: 12, fontFamily: 'inherit', background: '#fff' }}>
                      <option value="">Rok</option>
                      {Array.from({length: 6}, (_, i) => new Date().getFullYear() + i - 1).map(y => <option key={y} value={y}>{y}</option>)}
                    </select>
                  </div>
                </div>
                <div>
                  <label style={{ display: 'block', fontSize: 11, fontWeight: 600, color: '#6b7280', marginBottom: 4 }}>Realizace do</label>
                  <div style={{ display: 'flex', gap: 4 }}>
                    <select value={filters.realization_to ? filters.realization_to.split('-')[1] : ''} onChange={e => { const y = filters.realization_to ? filters.realization_to.split('-')[0] : new Date().getFullYear(); setF('realization_to', e.target.value ? `${y}-${e.target.value}` : ''); }} style={{ flex: 1, padding: '7px 6px', border: '1.5px solid #e5e7eb', borderRadius: 7, fontSize: 12, fontFamily: 'inherit', background: '#fff' }}>
                      <option value="">Měs.</option>
                      {['01','02','03','04','05','06','07','08','09','10','11','12'].map((m,i) => <option key={m} value={m}>{['Led','Úno','Bře','Dub','Kvě','Čer','Čvc','Srp','Zář','Říj','Lis','Pro'][i]}</option>)}
                    </select>
                    <select value={filters.realization_to ? filters.realization_to.split('-')[0] : ''} onChange={e => { const m = filters.realization_to ? filters.realization_to.split('-')[1] : '01'; setF('realization_to', e.target.value ? `${e.target.value}-${m}` : ''); }} style={{ flex: 1, padding: '7px 6px', border: '1.5px solid #e5e7eb', borderRadius: 7, fontSize: 12, fontFamily: 'inherit', background: '#fff' }}>
                      <option value="">Rok</option>
                      {Array.from({length: 6}, (_, i) => new Date().getFullYear() + i - 1).map(y => <option key={y} value={y}>{y}</option>)}
                    </select>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      )}

      {(isAdmin ? filtered : projects).length === 0 && !showForm ? (
        <div style={{ textAlign: 'center', padding: 60, color: '#9ca3af' }}>{t('noProjects')}</div>
      ) : (
        <div style={{ display: 'grid', gap: 14 }}>
          {(isAdmin ? filtered : projects).map(p => {
            const s = STATUS_STYLE[p.status] || STATUS_STYLE.pending;
            return (
              <div key={p.id} style={{ background: '#fff', borderRadius: 12, padding: '20px 24px', boxShadow: '0 1px 6px rgba(0,0,0,0.06)', border: '1px solid #f3f4f6', borderLeft: `4px solid ${s.color}` }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 12 }}>
                  <div style={{ flex: 1 }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 6, flexWrap: 'wrap' }}>
                      <h3 style={{ margin: 0, fontSize: 16, fontWeight: 700, color: '#111827' }}>{p.project_name}</h3>
                      {p.project_number && <span style={{ fontSize: 11, fontWeight: 700, color: '#6b7280', background: '#f3f4f6', padding: '2px 8px', borderRadius: 10, fontFamily: 'monospace' }}>{p.project_number}</span>}
                      <span style={{ background: s.bg, color: s.color, fontSize: 12, fontWeight: 700, padding: '2px 10px', borderRadius: 20 }}>{s.icon} {t(s.label)}</span>
                      {isAdmin && p.company_name && <span style={{ background: '#f0f9ff', color: '#0369a1', fontSize: 11, fontWeight: 600, padding: '2px 8px', borderRadius: 10 }}>{p.company_name}</span>}
                    </div>
                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '4px 20px', fontSize: 13, color: '#6b7280' }}>
                      <span>🏢 {p.end_customer}</span>
                      {p.end_customer_address && <span>📍 {p.end_customer_address}</span>}
                      {p.end_customer_ico && <span>🏛️ IČ: {p.end_customer_ico}</span>}
                      {p.subdistributor_name && <span style={{ color: '#0e76bc', fontWeight: 600 }}>🏪 {p.subdistributor_name}</span>}
                      {p.realization_date && <span>📆 {new Date(p.realization_date + '-01').toLocaleDateString('cs-CZ', { month: 'long', year: 'numeric' })}</span>}
                      {p.estimated_value > 0 && <span>💰 {Number(p.estimated_value).toLocaleString(locale)} {p.currency}</span>}
                      {p.discount_percent && <span style={{ color: '#166534', fontWeight: 600 }}>🏷️ Sleva {p.discount_percent}%</span>}
                      <span>📅 {new Date(p.created_at).toLocaleDateString(locale)}</span>
                    </div>

                    {p.items && p.items.length > 0 && (
                      <div style={{ marginTop: 12, border: '1px solid #f3f4f6', borderRadius: 8, overflow: 'hidden' }}>
                        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
                          <thead>
                            <tr style={{ background: '#f9fafb' }}>
                              <th style={{ padding: '6px 12px', textAlign: 'left', color: '#6b7280', fontWeight: 600, borderBottom: '1px solid #f3f4f6' }}>Produkt</th>
                              <th style={{ padding: '6px 12px', textAlign: 'left', color: '#6b7280', fontWeight: 600, borderBottom: '1px solid #f3f4f6' }}>SKU</th>
                              <th style={{ padding: '6px 12px', textAlign: 'center', color: '#6b7280', fontWeight: 600, borderBottom: '1px solid #f3f4f6' }}>Množství</th>
                              <th style={{ padding: '6px 12px', textAlign: 'left', color: '#6b7280', fontWeight: 600, borderBottom: '1px solid #f3f4f6' }}>Poznámka</th>
                              {canSeePrices && <th style={{ padding: '6px 12px', textAlign: 'right', color: '#6b7280', fontWeight: 600, borderBottom: '1px solid #f3f4f6' }}>Jedn. cena</th>}
                              {canSeePrices && <th style={{ padding: '6px 12px', textAlign: 'right', color: '#6b7280', fontWeight: 600, borderBottom: '1px solid #f3f4f6' }}>Sleva %</th>}
                              {canSeePrices && <th style={{ padding: '6px 12px', textAlign: 'right', color: '#166534', fontWeight: 600, borderBottom: '1px solid #f3f4f6' }}>Celkem</th>}
                            </tr>
                          </thead>
                          <tbody>
                            {p.items.map((item, i) => (
                              <tr key={i} style={{ borderBottom: i < p.items.length - 1 ? '1px solid #f9fafb' : 'none' }}>
                                <td style={{ padding: '6px 12px', fontWeight: 600, color: '#111827' }}>{item.product_name}</td>
                                <td style={{ padding: '6px 12px', color: '#9ca3af', fontSize: 12 }}>{item.product_sku}</td>
                                <td style={{ padding: '6px 12px', textAlign: 'center', fontWeight: 700, color: '#374151' }}>{item.quantity}</td>
                                <td style={{ padding: '6px 12px', color: '#6b7280' }}>{item.note}</td>
                                {canSeePrices && <td style={{ padding: '6px 12px', textAlign: 'right', color: '#374151' }}>{item.unit_price != null ? Number(item.unit_price).toLocaleString('cs-CZ') : '—'}</td>}
                                {canSeePrices && <td style={{ padding: '6px 12px', textAlign: 'right', color: '#374151' }}>{item.discount_percent != null ? item.discount_percent + '%' : '—'}</td>}
                                {canSeePrices && <td style={{ padding: '6px 12px', textAlign: 'right', fontWeight: 700, color: '#166534' }}>{item.final_price != null ? Number(item.final_price).toLocaleString('cs-CZ') : '—'}</td>}
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    )}

                    {p.admin_note && (
                      <div style={{ marginTop: 10, padding: '8px 12px', background: '#f9fafb', borderRadius: 6, fontSize: 13, color: '#374151', borderLeft: '3px solid #e5e7eb' }}>💬 {p.admin_note}</div>
                    )}
                    {!canSeePrices && p.status === 'approved' && (
                      <div style={{ marginTop: 10, padding: '10px 14px', background: '#f0fdf4', borderRadius: 6, fontSize: 13, color: '#166534', borderLeft: '3px solid #86efac', fontWeight: 600 }}>
                        ✅ {t('projectApprovedPriceNote') || 'Projekt byl schválen. Konkrétní cenu získáte od svého dodavatele.'}
                      </div>
                    )}
                    {canSeePrices && p.i6_reference && (
                      <div style={{ marginTop: 6, padding: '8px 12px', background: '#f0f9ff', borderRadius: 6, fontSize: 13, color: '#0369a1', borderLeft: '3px solid #bae6fd', fontWeight: 600 }}>🔗 i6: {p.i6_reference}</div>
                    )}

                    {isAdmin && editing === p.id && (
                      <EditProjectInline p={p} t={t} onSave={(data) => updateProject(p.id, data)} onCancel={() => setEditing(null)} />
                    )}
                  </div>

                  {isAdmin && (
                    <div style={{ display: 'flex', gap: 8, flexShrink: 0 }}>
                      <button onClick={() => { setEditingAdmin(p); setEditing(null); window.scrollTo(0,0); }} style={{ background: '#f0f9ff', border: '1px solid #bae6fd', color: '#0369a1', borderRadius: 8, padding: '7px 14px', fontSize: 13, fontWeight: 600, cursor: 'pointer', fontFamily: 'inherit' }}>
                        ✏️ Upravit
                      </button>
                      <button onClick={() => setEditing(editing === p.id ? null : p.id)} style={{ background: editing === p.id ? '#e8f4fc' : '#f9fafb', border: '1px solid #e5e7eb', color: editing === p.id ? '#0e76bc' : '#374151', borderRadius: 8, padding: '7px 14px', fontSize: 13, fontWeight: 600, cursor: 'pointer', fontFamily: 'inherit' }}>
                        {editing === p.id ? 'Zavřít' : 'Vyřídit'}
                      </button>
                    </div>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
